import type { Location } from 'react-router'

/** Estado de navegação com a rota de retorno depois do login. */
export interface ReturnToState {
  from?: string
}

const AUTH_PATHS = ['/login', '/esqueci-senha', '/redefinir-senha', '/trocar-senha']

/** Só caminhos internos (nada de "//outro-site" ou URL absoluta) e fora das telas de acesso. */
export function safeReturnPath(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null
  if (value.includes('\\')) return null
  return AUTH_PATHS.some((path) => value === path || value.startsWith(`${path}/`)) ? null : value
}

export function returnToFrom(location: Pick<Location, 'state'>): string | null {
  const state = location.state as ReturnToState | null
  return safeReturnPath(state?.from)
}

export function locationPath(location: Pick<Location, 'pathname' | 'search' | 'hash'>): string {
  return `${location.pathname}${location.search}${location.hash}`
}
